export function initializeFacebookSDK(appId) {
  return new Promise((resolve) => {
    // First, check if FB is already initialized
    if (window.FB) {
      console.log("FB already initialized");
      resolve(window.FB);
      return;
    }

    // Add FB init function
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: "v22.0",
      });
      console.log("FB initialized in fbAsyncInit");
      resolve(window.FB);
    };

    // Load the SDK if not already present
    if (!document.getElementById("facebook-jssdk")) {
      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });
}

export function isFacebookSDKInitialized() {
  return typeof window.FB !== "undefined";
}
